import { render } from "./PrivateAdd.vue?vue&type=template&id=00e5f836&scoped=true"
import script from "./PrivateAdd.vue?vue&type=script&lang=js"
export * from "./PrivateAdd.vue?vue&type=script&lang=js"

import "./PrivateAdd.vue?vue&type=style&index=0&id=00e5f836&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e5f836"]])

export default __exports__